
$(document).ready(function () {
    $('.spottercelebs').slick({
      dots: true,
      arrows: false,
      speed: 300,
      autoplay: false,
      infinite: false,
      slidesToShow: 3,
      variableWidth: true,
      slidesToScroll: 1,
      prevArrow:
        '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0604/8828/6399/files/Group_137.png?v=1717400353" alt=""></button>',
      nextArrow:
        '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0604/8828/6399/files/Group_138.png?v=1717400353" alt=""></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            dots: true,
            slidesToScroll: 2,
            infinite: true
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            dots: true,
            slidesToScroll: 1
          },
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            centerMode: false,
            slidesToShow: 1.5,
            slidesToScroll: 1
          },
        },
      ],
    });
    const spotedcelebsEl = document.querySelector('.spotedcelebs .slick-track');
    const spotedcelebsElRect = spotedcelebsEl.getBoundingClientRect();
    const spotedcelebsElHeight = spotedcelebsElRect.height;
    spotedcelebsEl.setAttribute('style', `--slick-track-height: ${spotedcelebsElHeight}px;`);
    const slickTrackChildren = spotedcelebsEl.children.length
    if (slickTrackChildren <= 4 && window.innerWidth > 1024){
      const slickDotsList = document.querySelectorAll('.spotedcelebs .slick-dots li');
      slickDotsList.forEach(eachDot => {
          eachDot.style.display = "none";
      })
    }
  });
//  popup js
document.addEventListener('DOMContentLoaded', function () {
  const popUpContent = document.querySelector('.spotedcelebs-popup');
  const popUpImageContainer = popUpContent.querySelector('.pop-up-image-ele');
  const crossButton = document.querySelector('.cross-icon-svg');

  crossButton.addEventListener('click', function () {
    popUpContent.style.display = 'none';
    document.body.classList.remove('overflow-hidden');
  });

  const mainSlides = document.querySelectorAll('.sp_blockwrap');

  mainSlides.forEach((slide) => {
    const imgElement = slide.querySelector('img');
    if (imgElement){
      imgElement.addEventListener('click', function(){
        const imgHTML = imgElement.outerHTML;
        popUpImageContainer.innerHTML = imgHTML;
        
        popUpContent.style.display = 'block';
        document.body.classList.add('overflow-hidden');
      })
    }
  });

  // Close the popup when clicking outside the image container
  popUpContent.addEventListener('click', function (e) {
    if (!popUpImageContainer.contains(e.target) && !crossButton.contains(e.target)) {
      popUpContent.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
    }
  });
});
